/* ============================================================
   APOC-style Theme — global.js
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Header: scrolled state ---------- */
  const header = document.querySelector('.site-header');
  const onScroll = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 4);
    const btt = document.querySelector('.back-to-top');
    if (btt) btt.classList.toggle('is-visible', window.scrollY > 600);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Back to top ---------- */
  document.querySelectorAll('.back-to-top').forEach((btn) => {
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  });

  /* ---------- Mobile drawer ---------- */
  const drawer = document.querySelector('.mobile-drawer');
  document.querySelectorAll('[data-drawer-open]').forEach((btn) =>
    btn.addEventListener('click', () => drawer && drawer.classList.add('is-open'))
  );
  document.querySelectorAll('[data-drawer-close]').forEach((btn) =>
    btn.addEventListener('click', () => drawer && drawer.classList.remove('is-open'))
  );

  /* ---------- Search overlay ---------- */
  const overlay = document.querySelector('.search-overlay');
  const searchInput = overlay ? overlay.querySelector('.search-overlay__input') : null;
  document.querySelectorAll('[data-search-open]').forEach((btn) =>
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!overlay) return;
      overlay.classList.toggle('is-open');
      if (overlay.classList.contains('is-open') && searchInput) searchInput.focus();
    })
  );
  document.querySelectorAll('[data-search-close]').forEach((btn) =>
    btn.addEventListener('click', () => overlay && overlay.classList.remove('is-open'))
  );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay) overlay.classList.remove('is-open');
  });

  /* ---------- Predictive search ---------- */
  const resultsBox = overlay ? overlay.querySelector('.search-overlay__results') : null;
  let searchTimer;
  if (searchInput && resultsBox && window.routes && window.routes.predictive_search_url) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { resultsBox.innerHTML = ''; return; }
      searchTimer = setTimeout(() => {
        fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const grid = doc.querySelector('[data-predictive-grid]');
            resultsBox.innerHTML = grid ? grid.innerHTML : '';
          })
          .catch(() => {});
      }, 250);
    });
  }

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = String(cart.item_count).padStart(2, '0');
        });
      })
      .catch(() => {});
  }
  window.refreshCartCount = refreshCartCount;

  /* ---------- Quick add ---------- */
  document.querySelectorAll('[data-quick-add]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = btn.getAttribute('data-quick-add');
      if (!id) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      })
        .then(() => { refreshCartCount(); btn.textContent = btn.getAttribute('data-added-label') || 'Added'; })
        .catch(() => { btn.disabled = false; })
        .finally(() => setTimeout(() => { btn.disabled = false; }, 1200));
    });
  });

  /* ---------- Wishlist (localStorage) ---------- */
  const WISHLIST_KEY = 'theme_wishlist';
  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  };
  const setWishlist = (items) => localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  window.getWishlist = getWishlist;

  function paintWishlistButtons() {
    const items = getWishlist();
    document.querySelectorAll('[data-wishlist-handle]').forEach((btn) => {
      btn.classList.toggle('is-active', items.includes(btn.getAttribute('data-wishlist-handle')));
    });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-wishlist-handle');
    let items = getWishlist();
    items = items.includes(handle) ? items.filter((h) => h !== handle) : items.concat(handle);
    setWishlist(items);
    paintWishlistButtons();
  });
  paintWishlistButtons();

  /* ---------- Carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach((wrap) => {
    const track = wrap.querySelector('[data-carousel-track]');
    if (!track) return;
    const step = () => Math.max(track.clientWidth * 0.8, 200);
    wrap.querySelectorAll('[data-carousel-prev]').forEach((b) =>
      b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }))
    );
    wrap.querySelectorAll('[data-carousel-next]').forEach((b) =>
      b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }))
    );
  });

  /* ---------- Collection: filters & sort panels ---------- */
  document.querySelectorAll('[data-toggle-target]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = document.querySelector(btn.getAttribute('data-toggle-target'));
      if (target) target.classList.toggle('is-open');
    });
  });

  /* ---------- Collection: view density ---------- */
  const grid = document.querySelector('[data-product-grid]');
  if (grid) {
    const saved = localStorage.getItem('theme_grid_columns');
    if (saved) grid.setAttribute('data-columns', saved);
    const syncButtons = () => {
      document.querySelectorAll('[data-view-columns]').forEach((b) =>
        b.classList.toggle('is-active', b.getAttribute('data-view-columns') === grid.getAttribute('data-columns'))
      );
    };
    document.querySelectorAll('[data-view-columns]').forEach((b) =>
      b.addEventListener('click', () => {
        grid.setAttribute('data-columns', b.getAttribute('data-view-columns'));
        localStorage.setItem('theme_grid_columns', b.getAttribute('data-view-columns'));
        syncButtons();
      })
    );
    syncButtons();
  }

  /* ---------- Collection: auto-submit filters ---------- */
  document.querySelectorAll('[data-filter-form] input[type="checkbox"]').forEach((input) => {
    input.addEventListener('change', () => input.closest('form').submit());
  });
  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.closest('form').submit());
  });

  /* ---------- Product page: thumbnails scroll ---------- */
  document.querySelectorAll('.product-thumbs__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = document.getElementById(btn.getAttribute('data-media-target'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Product page: variant selection ---------- */
  const productForms = document.querySelectorAll('[data-product-form]');
  productForms.forEach((form) => {
    const productJson = document.getElementById('ProductJson-' + form.getAttribute('data-section-id'));
    if (!productJson) return;
    const product = JSON.parse(productJson.textContent);
    const selects = form.querySelectorAll('[data-option-select]');
    const atc = form.querySelector('[data-atc]');
    const idInput = form.querySelector('[name="id"]');
    const priceBox = document.querySelector('[data-price-box="' + form.getAttribute('data-section-id') + '"]');

    function currentOptions() {
      return Array.from(selects).map((s) => s.value);
    }
    function findVariant() {
      const opts = currentOptions();
      return product.variants.find((v) =>
        v.options.every((opt, i) => opt === opts[i])
      );
    }
    function update() {
      const variant = findVariant();
      if (!variant) {
        if (atc) { atc.disabled = true; atc.textContent = atc.getAttribute('data-unavailable-label'); }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? atc.getAttribute('data-add-label') : atc.getAttribute('data-soldout-label');
      }
      if (priceBox) {
        const fmt = (cents) => (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.themeCurrency || 'USD' });
        priceBox.innerHTML = variant.compare_at_price > variant.price
          ? '<s>' + fmt(variant.compare_at_price) + '</s> ' + fmt(variant.price)
          : fmt(variant.price);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach((s) => s.addEventListener('change', update));
  });

  /* ---------- Product page: quantity ---------- */
  document.querySelectorAll('[data-pqty-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[data-pqty-input]');
      if (!input) return;
      const delta = Number(btn.getAttribute('data-pqty-btn'));
      input.value = Math.max(1, (Number(input.value) || 1) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.querySelectorAll('input[data-pqty-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const n = Math.max(1, Math.floor(Number(input.value) || 1));
      input.value = n;
    });
  });

  /* ---------- Product recommendations (API) ---------- */
  document.querySelectorAll('[data-product-recommendations]').forEach((box) => {
    const url = box.getAttribute('data-url');
    if (!url) return;
    const load = () => {
      fetch(url)
        .then((r) => (r.ok ? r.text() : Promise.reject()))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-product-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) box.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            load();
          });
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      io.observe(box);
    } else {
      load();
    }
  });

  /* ---------- Cart page: quantity ---------- */
  document.querySelectorAll('[data-qty-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[data-qty-input]');
      const delta = Number(btn.getAttribute('data-qty-btn'));
      const next = Math.max(0, Number(input.value) + delta);
      input.value = next;
      updateLine(input);
    });
  });
  document.querySelectorAll('input[data-qty-input]').forEach((input) => {
    input.addEventListener('change', () => updateLine(input));
  });
  let qtyTimer;
  function updateLine(input) {
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(() => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(input.getAttribute('data-line')), quantity: Number(input.value) }),
      }).then(() => window.location.reload());
    }, 300);
  }

  /* ---------- Cookie banner ---------- */
  const cookieBanner = document.querySelector('.cookie-banner');
  if (cookieBanner && !localStorage.getItem('theme_cookies_accepted')) {
    setTimeout(() => cookieBanner.classList.add('is-visible'), 800);
  }
  document.querySelectorAll('[data-cookie-accept]').forEach((btn) =>
    btn.addEventListener('click', () => {
      localStorage.setItem('theme_cookies_accepted', '1');
      if (cookieBanner) cookieBanner.classList.remove('is-visible');
    })
  );

  /* ---------- Wishlist page ---------- */
  const wishlistGrid = document.querySelector('[data-wishlist-grid]');
  if (wishlistGrid) {
    const handles = getWishlist();
    if (!handles.length) {
      wishlistGrid.innerHTML = '<p class="text-muted" style="padding:40px 0">' + (wishlistGrid.getAttribute('data-empty-label') || 'Your wishlist is empty.') + '</p>';
    } else {
      Promise.all(
        handles.map((h) => fetch('/products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null))
      ).then((products) => {
        wishlistGrid.innerHTML = '';
        products.filter(Boolean).forEach((p) => {
          const img = p.featured_image ? p.featured_image.replace(/(\.[^.]*)$/, '_600x$1') : '';
          const price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.themeCurrency || 'USD' });
          const card = document.createElement('a');
          card.className = 'product-card';
          card.href = p.url;
          card.innerHTML =
            '<div class="product-card__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="product-card__info">' +
            '<span class="product-card__vendor">' + (p.vendor || '') + '</span>' +
            '<span class="product-card__title">' + p.title + '</span>' +
            '<span class="product-card__price">' + price + '</span></div>';
          wishlistGrid.appendChild(card);
        });
      });
    }
  }
})();
